import React from 'react';
import { Card, Button, List, Typography, Tag, Input } from 'antd';
import Title from '../../component/title';
import Fetch from '../../Fetch';
import { MyLink } from '../../component/link';
import ActionsItem from './editdeleteaction';
import { bookTypeToString, bookLanguageToString } from '../../constant'

const Actions = props => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <MyLink to={'/book/add'}><Button type="primary">Tambah</Button></MyLink>
        </div>
    );
}

const BookItem = props => {
    const { record } = props;
    console.log(record);
    return (
        <List.Item key={record.id}>
            <div style={{ float: 'right' }}>
                <ActionsItem dataId={record.id} reload={props.reload} />
            </div>
            <div style={{ display: 'flex' }}>
                <div>
                    <MyLink to={`/book/${record.id}`}>
                        <img alt="sample" src={Fetch.getUrl(`/public/uploads/book/${record.images[0]}`)} style={{ width: 200, borderRadius: 10 }} />
                    </MyLink>
                </div>
                <div style={{ flexGrow: 1, paddingLeft: 24 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <MyLink to={`/book/${record.id}`}><Typography.Text strong style={{ fontSize: 16 }}>{record.title}</Typography.Text></MyLink>
                        <div><Tag color="orange">{bookTypeToString(record.type)}</Tag><Tag color="peru">{bookLanguageToString(record.language)}</Tag></div>
                        <div style={{ marginTop: 4 }}><Tag color="blue">{record.author}</Tag><Tag color="green">total / tersedia : {record.items.length} / {record.available}</Tag></div>
                        <div><Typography.Text>{record.description}</Typography.Text></div>
                        <div><Typography.Text disabled>{record.isbn} / {record.year}</Typography.Text></div>
                    </div>
                </div>
            </div>
        </List.Item>
    )
}

const PageBookList = props => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [pagination, setPagination] = React.useState({ total: 0, pageSize: 5, current: 1 });
    const [search, setSearch] = React.useState('');
    let timerId = -1;

    React.useEffect(() => {
        fetchData(0, pagination.pageSize);
    }, []);

    const fetchData = async (page, size, search = '') => {
        setLoading(true);
        const url = search === '' ?
            `/book?start=${page * size}&count=${size}` :
            `/book?start=${page * size}&count=${size}&filter[title]=${search}`;
        const res = await Fetch.get(url);
        setLoading(false);
        setData(res.data);
        if (pagination.total === 0)
            setPagination({ ...pagination, total: res.total_count })
    }

    const pageChange = (page) => {
        if (page === pagination.current) return;
        setPagination({ ...pagination, current: page })
        fetchData(page - 1, pagination.pageSize);
    }

    const searchChange = (val) => {
        const searchVal = val.target.value;
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            fetchData(0, pagination.pageSize, searchVal);
            setSearch(searchVal);
        }, 500);
    }

    return (
        <Card title={<Title title={"Daftar Buku"} actions={<Actions {...props} />} />}>
            <div style={{ float: 'right' }}>
                <Input.Search placeholder="Cari judul" style={{ width: 200, marginBottom: 20 }} onChange={searchChange} />
            </div>
            <div style={{ marginTop: 40 }}>
                <List loading={loading} itemLayout="vertical" size="large" pagination={{ ...pagination, onChange: pageChange }}
                    renderItem={item => <BookItem record={item} history={props.history} reload={() => { fetchData(pagination.current, pagination.pageSize, search); }} />} dataSource={data}
                />
            </div>
        </Card>
    );
}

export default PageBookList;